import React from "react"
import { Box, useTheme } from "@mui/material"

export const BotIcon = ({ botIcon, size }: { botIcon: string; size: "small" | "medium" }) => {
  const { palette } = useTheme()

  const stylesForSmallSize = {
    marginRight: { xs: "0.5rem", md: "1rem" },
    marginTop: { xs: "0.5rem", md: "0.9rem" },
    width: { xs: "40px", md: "60px" },
    height: { xs: "40px", md: "60px" }
  }

  const stylesForMediumSize = {
    marginRight: { xs: "1rem", md: "2rem" },
    marginTop: { xs: "1.5rem", md: "3rem" },
    width: { xs: "40px", md: "70px" },
    height: { xs: "40px", md: "70px" }
  }

  return (
    <Box
      sx={{
        backgroundColor: palette.primary.contrastText,
        borderRadius: "50%",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        ...(size === "small" ? stylesForSmallSize : stylesForMediumSize)
      }}
    >
      <img src={botIcon} alt="AI" style={{ width: "70%", height: "70%" }} />
    </Box>
  )
}
